import { toast } from "react-toastify";
export const toastNotify = (text: string, error?: boolean) => {
	(error ? toast.error : toast.success)(
		<div className="flex items-center">
			<div className="mr-4 ml-4 text-gray-900 pr-16">{text}</div>
		</div>
	);
};
class FrontendUtils {
	static downloadDataToHardDrive(data: any, filename: string) {
		const element = document.createElement("a");
		const file = new Blob([JSON.stringify(data, null, "\t")], { type: "text/plain" });
		element.href = URL.createObjectURL(file);
		element.download = filename;
		document.body.appendChild(element); // Required for this to work in FireFox
		element.click();
	}
}

export default FrontendUtils;
